import React from "react"

const NestedTitlePicture3 = (props) => {
    return(
        <div id="ntc3" className="nested-component"
            style={
                    {
                        width:`${props.width}`,
                        height:`${props.height}`,
                        backgroundColor:`${props.backgroundColor || "white"}`
                    }
                }
            >

            <div className="nested-container"
                style={{alignItems:`${props.center?"center":"unset"}`}}
            >
                <div className="background-filter"
                    style={{backgroundImage:`url( ${props.pictureURL} )`}} 
                />
                <div className="nested-title"
                    style={
                        {
                            color:`${props.color||"white"}`,
                            fontSize:`${props.fontSize||"medium"}`
                        }
                    }
                >
                    {props.title || "No title !"}
                    <div dangerouslySetInnerHTML={{ __html: props.text }}/>
                </div>
            </div>
        </div>
    )
}

export default NestedTitlePicture3